import { render, staticRenderFns } from "./FinalCollection.vue?vue&type=template&id=2875d81d&"
import script from "./FinalCollection.vue?vue&type=script&lang=js&"
export * from "./FinalCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports